export default __webpack_public_path__ + "static/media/portfolio4.9349fbe0.png";